import React from 'react';
import { Breakpoint, Sticky } from '@americanexpress/aqx-components';

/*
US3711477:
Why Breakpoint is needed here?
(1) unlike the original VAC filter, the pillbox filter uses the same filter instance for both
    desktop and mobile modes.
(2) this requires the sticky top position to be set based on the device modes
    and other conditions. 

Why Sticky.Item component alone is needed here?
(1) both the original VAC filter and the pillbox filter need to share the same Sticky.Container instance.
(2) this arrangement/module is created to reduce certain amount of logic being added
    to the page template level,    
*/

const PillboxStickyItemWrap = ({ children }) => {
  return (
    <Breakpoint>
      {({ sm }) => {
        return (
          <Sticky.Item $zIndex={8} $fixedTop={sm ? 0 : 60} $stickyTop={sm ? 0 : 60}>
            {children}
          </Sticky.Item>
        );
      }}
    </Breakpoint>
  );
};

export default React.memo(PillboxStickyItemWrap);
